<template>
  <span>
    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
      <q-date today-btn :value="dateValue" @input="(v) => {$refs.qDateProxy.hide(); $refs.qTimeProxy.show(); updateDate(v)}" />
    </q-popup-proxy>
    <q-popup-proxy ref="qTimeProxy" transition-show="scale" transition-hide="scale">
      <q-time now-btn :value="timeValue" @input="(v) => {$refs.qTimeProxy.hide(); updateTime(v); emitUpdate()}" />
    </q-popup-proxy>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MDateTimePicker',
  props: ['value'],
  computed: {
    dateValue () {      
      return moment(this.value).format('YYYY/MM/DD')
    },
    timeValue () {
      return moment(this.value).format('HH:mm')
    }
  },
  methods: {
    updateDate (val) {
      this.chosenDate = moment(val + ' 00:00').format('YYYY/MM/DD')
    },
    updateTime (val) {
      this.chosenTime = moment('2000/1/1 ' + val).format('HH:mm')
    },
    emitUpdate () {
      this.$emit('input', moment(this.chosenDate + ' ' + this.chosenTime, 'YYYY/MM/DD HH:mm'))
    },
    show () {
      this.$refs.qDateProxy.show()
    }
  },
  data () {
    return {
      chosenDate: '',
      chosenTime: ''
    }
  }
}
</script>

<style scoped>

</style>
